/** QA seed nav is hidden from production admin builds unless explicitly enabled. */
import { env } from '../env';

export const isQaSeedNavEnabled = (): boolean =>
  import.meta.env.DEV || env.VITE_QA_SEED_ENABLED === true;
